import React, { useState, useEffect, useCallback, useRef } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const AdminLayout = () => {


  // Scroll state
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);


  const mainRef = useRef(null);


  const toggleSidebar = () => {
    setMobileSidebarOpen(prev => !prev);
  };

  // Add scroll listener on <main>
  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;

    const onScroll = () => {
      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight - el.clientHeight;
      const progress = scrollTop / scrollHeight;
      setScrollProgress(progress);
      setShowScrollTop(scrollTop > 150);
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    mainRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  return (
    // <div className="flex h-screen bg-gray-100 overflow-hidden">
    //   {/* Mobile overlay only */}
    //   {mobileSidebarOpen && (
    //     <div
    //       className="fixed inset-0 bg-black/50 z-[90] md:hidden"
    //       onClick={() => setMobileSidebarOpen(false)}
    //     />
    //   )}

    //   {/* Sidebar */}
    //   <div
    //     className="w-16 shrink-0">
    //     <Sidebar
    //       mobileOpen={mobileSidebarOpen}
    //       closeMobile={() => setMobileSidebarOpen(false)}
    //     />
    //   </div>

    //   {/* MAIN */}
    //   <div className="flex-1 flex flex-col relative z-10">
    //     <Header toggleSidebar={toggleSidebar} />

    //     <main
    //       ref={mainRef}
    //       className="flex-1 p-4 md:p-4 overflow-auto"
    //     >
    //       <Outlet />
    //     </main>
    //   </div>
    // </div>

    <div className="flex h-screen bg-gray-100 overflow-hidden">

      {/* Mobile overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[90] md:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      {/* Desktop Sidebar */}
      <div className="hidden md:block w-16 relative">
        <Sidebar
          mobileOpen={mobileSidebarOpen}
          closeMobile={() => setMobileSidebarOpen(false)}
        />
      </div>

      {/* Mobile Sidebar */}
      <div className="md:hidden">
        <Sidebar
          mobileOpen={mobileSidebarOpen}
          closeMobile={() => setMobileSidebarOpen(false)}
        />
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 flex flex-col relative z-10">
        <Header toggleSidebar={toggleSidebar} />

        <main
          ref={mainRef}
          className="flex-1 p-4 overflow-auto"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default React.memo(AdminLayout);
